import { gql } from '@apollo/client'

export const TRIGGER_RELEASE_CLAUSE_PAYMENT = gql`
  mutation TriggerReleaseClausePayment($input: TriggerReleaseClausePaymentInput!) {
    triggerReleaseClausePayment(input: $input) {
      transferOffer {
        id
        amount
        status
        releaseClause
      }
      errors
    }
  }
`

export const INCREASE_RELEASE_CLAUSE = gql`
  mutation IncreaseReleaseClause($input: IncreaseReleaseClauseInput!) {
    increaseReleaseClause(input: $input) {
      fantasyTeamPlayer {
        id
        releaseClause
      }
      errors
    }
  }
`
